import React from "react";
import ProficiencyLevelIconControl from "../Common/ProficiencyLevelIconControl";

interface Props {
  score: number | undefined;
  meterPoints: number;
}

export default function MiniMeter({ score, meterPoints }: Props) {
  const getLevel = (): string => {
    if (!score) return "";
    else if (score === 1) return "newcomer";
    else if (score === 2) return "explorer";
    else if (score === 3) return "integrator";
    else if (score === 4) return "expert";
    else if (score === 5) return "leader";
    else if (score === 6) return "pioneer";
    return "";
  };

  const sixPointsMeter = (
    <>
      <div className="small-meter" style={{ position: "relative" }}>
        <svg
          version="1.1"
          id="small-meter"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="225px"
        >
          <g>
            <g>
              <path
                style={{ fill: "#D2D2D2" }}
                className="st0"
                d="M19.4,134.8l-0.2-0.5c-3.4-9.9-5.1-20.4-5.2-30.9c-0.1-9.8,1.3-19.5,4-28.8l0.1-0.5l38.1,12l-0.1,0.5
c-1.4,5.2-2.2,10.6-2.1,16c0.1,6.3,1.1,12.6,3.2,18.5l0.2,0.5L19.4,134.8z"
              />
            </g>
            <path
              style={{ fill: "#D2D2D2" }}
              className="st0"
              d="M56.8,84.3l-38-12.4l0.2-0.5c6-18.3,17.3-34.3,32.4-46.4l0.4-0.3l24.8,31.3l-0.4,0.3
c-9,7.1-15.6,16.6-19.2,27.4L56.8,84.3z"
            />
            <path
              style={{ fill: "#D2D2D2" }}
              className="st0"
              d="M77.6,55.3L53.4,23.5l0.4-0.3C70.1,11,89.6,4.3,110,3.7l0.5,0l0.7,40.3l-0.5,0C98.8,44.3,87.5,48.1,78,55
L77.6,55.3z"
            />
            <path
              style={{ fill: "#D2D2D2" }}
              className="st0"
              d="M146.6,55.3l-0.4-0.3c-9.6-7-21-10.8-32.9-11l-0.5,0l-0.1-40.3l0.5,0c20.6,0.1,40.3,6.4,57,18.4l0.4,0.3
L146.6,55.3z"
            />
            <path
              style={{ fill: "#D2D2D2" }}
              className="st0"
              d="M168.2,84.8l-0.2-0.5C164.3,73.5,157.6,64,148.5,57l-0.4-0.3l24.7-32.5l0.4,0.3c15.7,11.8,27.5,27.9,33.9,46.4
l0.2,0.5L168.2,84.8z"
            />
            <path
              style={{ fill: "#D2D2D2" }}
              className="st0"
              d="M207.8,135.1l-39.6-12.9l0.2-0.5c1.9-5.9,2.8-12,2.8-18.2c-0.1-5.6-0.9-11.2-2.6-16.6l-0.1-0.5l0.5-0.2
l38.9-12.4l0.2,0.5c3,9.4,4.6,19.3,4.7,29.3c0.1,10.6-1.5,21-4.7,31L207.8,135.1z"
            />
          </g>
          <g>
            <path
              style={
                score === 1
                  ? { fill: "#D1D1D1", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 1
                  ? { fill: "#FFFFFF" }
                  : { fill: "#D1D1D1" }
              }
              className="st1"
              d="M55.6,86.4L18.5,74.7c-2.7,9.1-4.1,18.7-4,28.7c0.1,10.8,1.9,21.1,5.2,30.8l37.1-12.9
c-2-5.9-3.2-12.2-3.3-18.7C53.4,97,54.2,91.6,55.6,86.4z"
            />
            <path
              style={
                score === 2
                  ? { fill: "#BEBEBE", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 2
                  ? { fill: "#FFFFFF" }
                  : { fill: "#BEBEBE" }
              }
              className="st2"
              d="M75.8,56.1L51.7,25.5C36.8,37.3,25.5,53.3,19.4,71.6l37,12C60.1,72.7,66.9,63.1,75.8,56.1z"
            />
            <path
              style={
                score === 3
                  ? { fill: "#ACACAC", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 3
                  ? { fill: "#FFFFFF" }
                  : { fill: "#ACACAC" }
              }
              className="st3"
              d="M110,4.2c-21,0.6-40.2,7.7-55.9,19.4l23.6,31c9.3-6.8,20.7-10.8,33-11.1L110,4.2z"
            />
            <path
              style={
                score === 4
                  ? { fill: "#9A9A9A", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 4
                  ? { fill: "#FFFFFF" }
                  : { fill: "#9A9A9A" }
              }
              className="st4"
              d="M169.9,22.5c-16-11.4-35.6-18.2-56.7-18.3l0.1,39.3c12.4,0.2,23.8,4.3,33.2,11.1L169.9,22.5z"
            />
            <path
              style={
                score === 5
                  ? { fill: "#888888", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 5
                  ? { fill: "#FFFFFF" }
                  : { fill: "#888888" }
              }
              className="st5"
              d="M168.5,84.1l38.1-13.1c-6.5-18.6-18.4-34.6-33.8-46.2l-24.1,31.7C157.8,63.6,164.7,73.1,168.5,84.1z"
            />
            <path
              style={
                score === 6
                  ? { fill: "#777777", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 6
                  ? { fill: "#FFFFFF" }
                  : { fill: "#777777" }
              }
              className="st6"
              d="M169,86.8c1.6,5.3,2.5,10.9,2.6,16.7c0.1,6.4-0.9,12.6-2.8,18.4l38.6,12.6c3.1-9.7,4.7-20.1,4.6-30.9
c-0.1-10.2-1.7-19.9-4.7-29.1L169,86.8z"
            />
          </g>
          <circle style={{ fill: "#777777" }} className="st6" cx="111.8" cy="102" r="47.1" />
        </svg>
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            width: "82px",
            left: "70px",
            textAlign: "center",
          }}
        >
          <ProficiencyLevelIconControl level={getLevel()} />
        </div>
      </div>
    </>
  );

  const threePointsMeter = (
    <>
      <div className="small-meter" style={{ position: "relative" }}>
        <svg
          version="1.1"
          id="small-meter"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="225px"
        >
<g>
<path
                style={{ fill:"none", stroke:"#D2D2D2", strokeWidth:"2px" }}
                className="st0"
                d="M76.1,56.3L51.8,25.6c-22.8,18.1-37.4,46.1-37.4,77.5c0,10.8,1.8,21.3,5,31l38.1-13c-2.1-6-3.2-12.4-3.2-19.1
		C54.2,83.5,62.7,67,76.1,56.3z"/>
            <path
              style={{ fill:"none", stroke:"#D2D2D2", strokeWidth:"2px" }}
              className="st0"
              d="M170,22.7l0.5-0.2C154.3,11,134.6,4.2,113.2,4.2c-22.1,0-42.6,7.3-59.1,19.6l23.5,30.9l0.2,0.2
		c9.8-7.3,21.9-11.6,35-11.6c12.7,0,24.5,4.1,34.1,10.9L170,22.7z"/>
            <path
              style={{ fill:"none", stroke:"#D2D2D2", strokeWidth:"2px" }}
              className="st0"
              d="M172.7,24.1l-0.3,0.5l-23.6,31l0,0c13.9,10.7,22.8,27.5,22.8,46.4c0,7-1.2,13.7-3.5,19.9l0.7,0l38.3,12.3
		c3.2-9.8,5-20.2,5-31.1C212.1,70.8,196.6,42.1,172.7,24.1z"/>
</g>
          <g>
            <path
              style={
                score === 2
                  ? { fill: "#D1D1D1", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 2
                  ? { fill: "#FFFFFF" }
                  : { fill: "#D1D1D1" }
              }
              className="st0" d="M76.1,56.3L51.8,25.6c-22.8,18.1-37.4,46.1-37.4,77.5c0,10.8,1.8,21.3,5,31l38.1-13c-2.1-6-3.2-12.4-3.2-19.1
		C54.2,83.5,62.7,67,76.1,56.3z"/>
            <path
              style={
                score === 4
                  ? { fill: "#ACACAC", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 4
                  ? { fill: "#FFFFFF" }
                  : { fill: "#ACACAC" }
              }
              className="st1" d="M170,22.7l0.5-0.2C154.3,11,134.6,4.2,113.2,4.2c-22.1,0-42.6,7.3-59.1,19.6l23.5,30.9l0.2,0.2
		c9.8-7.3,21.9-11.6,35-11.6c12.7,0,24.5,4.1,34.1,10.9L170,22.7z"/>
            <path
              style={
                score === 6
                  ? { fill: "#888888", stroke: "#f5a00c", strokeWidth: "5px" }
                  : score && score < 6
                  ? { fill: "#FFFFFF" }
                  : { fill: "#888888" }
              }
              className="st2" d="M172.7,24.1l-0.3,0.5l-23.6,31l0,0c13.9,10.7,22.8,27.5,22.8,46.4c0,7-1.2,13.7-3.5,19.9l0.7,0l38.3,12.3
		c3.2-9.8,5-20.2,5-31.1C212.1,70.8,196.6,42.1,172.7,24.1z"/>
          </g>
          <circle style={{ fill: "#777777" }} className="st6" cx="111.8" cy="102" r="47.1" />
        </svg>
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            width: "82px",
            left: "70px",
            textAlign: "center",
          }}
        >
          <ProficiencyLevelIconControl level={getLevel()} />
        </div>
      </div>
    </>
  );

  return (
    <>
      {meterPoints === 6 && sixPointsMeter}
      {meterPoints === 3 && threePointsMeter}
    </>
  );
}
